import React, { Suspense } from 'react';

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import UILoader from '@aquariuxfintech/aqx-trader-react-ui/loader';

import { AUTHENTICATION_ROUTES } from '@aqx-core/common/constants/router';
import { useAuthRoutes } from '@aqx-core/common/hooks/auth/use-auth-routes';

import ForgotPasswordScreen from './forgot-password';
import LoginScreen from './login';
import ResetPasswordScreen from './reset-password';
import AuthContainer from './shared/auth-container';
import SignUpCrmScreen from './sign-up-crm';
import SignUpDemoScreen from './sign-up-demo';

const AuthenticationRoutes: FCC = () => {
  const {
    hasLiveForgotPasswordRoute,
    hasCrmSignUpRoute,
    hasCrmForgotPasswordRoute,
    hasDemoResetPassword,
    hasDemoSignUpRoute
  } = useAuthRoutes();
  const { search } = useLocation();
  return (
    <Suspense fallback={<UILoader absolute />}>
      <AuthContainer>
        <Routes>
          <Route path={AUTHENTICATION_ROUTES.LOGIN} element={<LoginScreen />} />

          {hasCrmSignUpRoute && <Route path={AUTHENTICATION_ROUTES.SIGN_UP_CRM} element={<SignUpCrmScreen />} />}

          {hasCrmForgotPasswordRoute && (
            <Route path={AUTHENTICATION_ROUTES.FORGOT_PASSWORD_CRM} element={<ForgotPasswordScreen isCRM />} />
          )}

          {hasLiveForgotPasswordRoute && (
            <Route path={AUTHENTICATION_ROUTES.FORGOT_PASSWORD_LIVE} element={<ForgotPasswordScreen />} />
          )}

          {hasDemoResetPassword && (
            <Route path={AUTHENTICATION_ROUTES.RESET_PASSWORD} element={<ResetPasswordScreen />} />
          )}

          {hasDemoSignUpRoute && <Route path={AUTHENTICATION_ROUTES.SIGN_UP_DEMO} element={<SignUpDemoScreen />} />}

          <Route path="*" element={<Navigate to={`${AUTHENTICATION_ROUTES.LOGIN}${search}`} replace={true} />} />
        </Routes>
      </AuthContainer>
    </Suspense>
  );
};

export default AuthenticationRoutes;
